import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PontuacaoService } from './pontuacao.service';
import { LoadingService } from '../../../util/loader.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
const swal = require('sweetalert');
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
const b64toBlob = require('b64-to-blob');
@Component({
  selector: 'app-pontuacao',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './pontuacao.component.html',
  styleUrls: ['./pontuacao.component.scss']
})
export class PontuacaoComponent implements OnInit {
  cartoes = [];
  cartao_selecionado = null;
  info_pontuacao = null;
  celular_cliente = null;
  public valor_consumido: number;
  consultando_cliente = false;
  private searchControl: FormControl;
  private debounce: number = 400;
  valForm: FormGroup;
  pontuacao: number = 0;
  quantidadeDePontos: number = 10;
  possuiValidade: boolean = false;
  dataFimValidade: string = "";
  descricaoCartao: string = "";

  valFormCadastro: FormGroup;
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();
  bsConfig = {
    containerClass: 'theme-angle',
    dateInputFormat: 'DD/MM/YYYY'
  };
  novoUsuario = {
    configId: null,
    name: null,
    phone: null,
    dataNascimento: null,
    sexo: null,
    valor:0
  };
  finalizarCartao = false;
  clientes = [];

  clientesPontuadosDia = [];
  gender = [{ value: 0, description: "Masculino" }, { value: 1, description: "Feminino" }];

  constructor(private service: PontuacaoService, public loader: LoadingService, public fb: FormBuilder, private _localeService: BsLocaleService) {
    this._localeService.use('pt');
    this.valForm = this.fb.group({
      'pontuarNumero': [null, Validators.required],
      'pontuarCartao': [null, Validators.required],
      'pontuarValor': [null, null],
    });
    this.carregarCartoes();
    this.carregarClientes();
    this.carregarClientesPontuadoDia();


    this.valFormCadastro = this.fb.group({
      'cadastrarNome': [null, Validators.required],
      'cadastrarCelular': [null, Validators.required],
      'cadastrarDataNascimento': [null, null],
      'cadastrarSexo': [null, null]
    });


  }

  limparForm() {
    this.novoUsuario = {
      configId: null,
      name: null,
      phone: null,
      dataNascimento: null,
      sexo: null,
      valor:0
    };
    this.valor_consumido = 0;
  }
  limpar() {
    this.cartao_selecionado = null;
    this.info_pontuacao = null;
    this.celular_cliente = null;
    this.consultando_cliente = false;
    this.limparCartao();
    this.limparForm();
  }

  limparCartao() {
    this.pontuacao = 0;
    this.quantidadeDePontos = 10;
    this.possuiValidade = false;
    this.dataFimValidade = "";
    this.descricaoCartao = "";
  }
  onSelectCard(event) {
    this.cosultarCliente(this.celular_cliente);
  }
  downloadCartao() {
    this.loader.show('body');
    if (this.info_pontuacao.cartao != null) {
      this.service.downloadCartao(this.info_pontuacao.cartao.id_cartao_usuario).subscribe(result => {

        // const blob = b64toBlob(result.data.fileBase64, result.data.fileType);
        // var mediaType = 'application/pdf';
        // var blob = new Blob([result.blob()], { type: mediaType });
        saveAs(result, "cartao_fidelidade.pdf");
        this.loader.hide('body');
      });
    }
  }
  montarBotaoPontuar() {
    if (this.info_pontuacao != null) {
      const quantidadeDePontos = this.info_pontuacao.configuracao.quantidade_de_pontos;
      let pontos = null;
      if (this.info_pontuacao.cartao != null && this.info_pontuacao.cartao.pontos != null) {
        pontos = this.info_pontuacao.cartao.pontos.length;
      }
      if (pontos == null) {
        this.finalizarCartao = false;
      } else {
        this.finalizarCartao = pontos == null || pontos !== quantidadeDePontos ? false : pontos = quantidadeDePontos;
      }
    }
  }
  pontuarCliente() {
    if (this.info_pontuacao != null) {
      if (this.info_pontuacao.usuario != null) {
        let item = {
          configId: this.info_pontuacao.configuracao.id_cartao,
          userId: this.info_pontuacao.usuario.id_usuarios,
          phone: this.info_pontuacao.usuario.celular,
          valor: this.valor_consumido
        };
        this.loader.show("body");
        this.service.pontuarCliente(item).subscribe((resultado) => {
          this.loader.hide("body");
          this.valor_consumido = 0;
          this.info_pontuacao.cartao = resultado;
          this.pontuacao = this.info_pontuacao.cartao.pontos.length;
          this.montarBotaoPontuar();
          this.carregarClientesPontuadoDia();
        });

      } else {


        //REGISTAR E PONTIUAR
      }
    }
  }


  montarDadosCartao(record) {
    if (record != null) {
      this.limparCartao();
      this.quantidadeDePontos = record.configuracao.quantidade_de_pontos;
      this.descricaoCartao = record.configuracao.descricao;
      this.possuiValidade = record.configuracao.possui_validade;
      this.dataFimValidade = this.parseBool(record.configuracao.possui_validade) ?
        (moment(record.configuracao.data_fim_validade).isValid() ? moment(new Date(record.configuracao.data_fim_validade)).format("DD/MM/YYYY") : this.formatDateBr(record.configuracao.data_fim_validade)) : ""

      // this.dataFimValidade = record.configuracao.data_fim_validade;
      if (record.cartao != null && record.cartao.pontos != null) {
        this.pontuacao = record.cartao.pontos.length;
      }
      this.montarBotaoPontuar();
    }
  }

  marcarCartaoCompleto() {
    if (this.info_pontuacao != null) {
      if (this.info_pontuacao.usuario != null) {
        let item = {
          configId: this.info_pontuacao.configuracao.id_cartao,
          userId: this.info_pontuacao.usuario.id_usuarios,
          phone: this.info_pontuacao.usuario.celular,
          valor: this.valor_consumido
        };
        this.loader.show("body");
        this.service.marcarCartaoCompleto(item).subscribe((resultado) => {
          this.loader.hide("body");
          this.info_pontuacao.cartao = resultado;
          this.cosultarCliente(this.celular_cliente);
          this.montarBotaoPontuar();
          this.montarDadosCartao(this.info_pontuacao);
          this.carregarClientesPontuadoDia();
        });

      } else {


        //REGISTAR E PONTIUAR
      }
    }
  }

  cadastrarEpontuar($ev, value, buttonType: string) {
    $ev.preventDefault();
    for (const c in this.valFormCadastro.controls) {
      this.valFormCadastro.controls[c].markAsTouched();
    }
    if (this.valFormCadastro.valid) {
      this.novoUsuario.configId = this.info_pontuacao.configuracao.id_cartao;
      this.novoUsuario.valor = this.valor_consumido;
      this.loader.show("body");
      this.service.cadastrarEPontuar(this.novoUsuario).subscribe((itens) => {
        this.loader.hide("body");
        this.info_pontuacao = itens;
        this.valor_consumido = 0;
        this.montarDadosCartao(itens);
        this.carregarClientesPontuadoDia();
      });
    }
  }

  cosultarCliente(celular) {
    if (this.cartao_selecionado == null) {
      swal('Atenção', 'Selecione uma configuracao de cartão fidelidade!', 'warning');
    } else {
      if (celular != null && this.cartao_selecionado != null) {
        this.loader.show("body");
        this.service.consultarUsuario(this.cartao_selecionado, celular).subscribe((itens) => {
          this.consultando_cliente = true;
          this.loader.hide("body");
          this.info_pontuacao = itens;
          if (itens != null) {
            this.montarDadosCartao(itens);
            if (itens.usuario == null) {
              this.novoUsuario.phone = celular;
            }
          }
        });
      }
    }
  }

  ngOnInit() {
    this.valForm.controls['pontuarNumero'].valueChanges
      .pipe(debounceTime(this.debounce), distinctUntilChanged())
      .subscribe(query => {
        console.log(query);
        if (query != null && query.length === 11) {
          this.cosultarCliente(query);
        }
      });
  }

  carregarCartoes() {
    this.service.listarCartoes().subscribe((itens) => {
      this.cartoes = itens;
    });
  }

  carregarClientes() {
    this.service.listarUsuarios().subscribe((itens) => {
      this.clientes = itens;
    });
  }
  carregarClientesPontuadoDia() {
    this.service.listarUsuariosPontuadosDodia().subscribe((itens) => {
      this.clientesPontuadosDia = itens;
    });
  }



  celularChange(newValue) {
    console.log(newValue);
  }
  parseBool(b) {
    return !(/^(false|0)$/i).test(b) && !!b;
  }
  formatDateBr(dateString): string {
    var dataSplit = dateString.split('/');
    var dateConverted;

    if (dataSplit[2].split(" ").length > 1) {

      var hora = dataSplit[2].split(" ")[1].split(':');
      dataSplit[2] = dataSplit[2].split(" ")[0];
      dateConverted = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0], hora[0], hora[1]);

    } else {
      dateConverted = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);
    }

    return dateConverted;
  }
}
